
import { WPXFormValue } from '@/components/templates/WPXForm';
import { BackupRepoRepositoryInterface } from '@/services/Backup/interfaces/index';
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import CreateBackupRepoForm from "@/services/Backup/forms/CreateBackupRepoForm";
import ServerPicker from "@/components/server/ServerPicker.vue";
import { ServerRepositoryInterface } from "@/services/Server/Interfaces";
import BackupServerPicker from "@/components/backups/BackupServerPicker.vue";
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: { BackupServerPicker, ServerPicker, PageHeader },
  inject: [
    'backupRepoRepository',
    'serverRepository'
  ],
})
export default class CreateBackupRepository extends Vue {
  public backupRepoRepository: BackupRepoRepositoryInterface;
  public serverRepository: ServerRepositoryInterface;

  public isLoading: boolean = false;
  public form: WPXFormValue<CreateBackupRepoForm> = new WPXFormValue(CreateBackupRepoForm);

  public async createBackupRepo(): Promise<void> {
    try {
      this.isLoading = true;

      const server = this.form.data.originServerId
        ? await this.serverRepository.getServer(this.form.data.originServerId)
        : undefined;

      await this.backupRepoRepository.createBackupRepo({
        repositoryPath: this.form.data.repositoryPath,
        repositoryPasswordPath: this.form.data.repositoryPasswordPath,
        repositoryPassword: this.form.data.repositoryPassword,
        repositoryId: this.form.data.repositoryId,
        originServerId: this.form.data.originServerId,
        backupServer: this.form.data.backupServer,
        originServerHostname: server?.hostname ?? "",
        retentionDays: this.form.data.retentionDays,
      });

      this.$successDialog.show(`Backup Repo ${this.form.data.repositoryId} creation successful!`);

      this.$router.push({
        name: 'backup_repositories',
      });
    } catch (err) {
      this.onError(err);
    } finally {
      this.isLoading = false;
    }
  }

  private async onError(err: unknown): Promise<void> {
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}
